import React from 'react';
import { graphql } from 'gatsby';

import { Box, Container } from '@mui/material';

import { SecondaryBannerColumnLayout } from './column-layout';
import { SecondaryBannerServiceLayout } from './service-layout';

// ********************************************************************************
export const secondaryBannerMapping = (props: any, locale: string) => {
  let suffix = '_en';
  if (locale === 'es') {
    suffix = '_es';
  }
  return {
    title: props['title' + suffix],
    description: props['description' + suffix],
    layout: props.layout,
  };
};

enum Layout {
  COLUMN = 1,
  SERVICE = 2,
}

type Props = { title: string; description: string; layout: number };
export const SecondaryBanner = (props: Props) => {
  // == Render ====================================================================
  const layoutRender = () => {
    switch (props.layout) {
      case Layout.COLUMN:
        return <SecondaryBannerColumnLayout title={props.title} description={props.description} />;
      case Layout.SERVICE:
        return <SecondaryBannerServiceLayout title={props.title} description={props.description} />;
      default:
        return <SecondaryBannerColumnLayout title={props.title} description={props.description} />;
    }
  };

  return (
    <Box
      component="section"
      display="flex"
      alignItems="center"
      justifyContent="center"
      minHeight={{ xs: 'auto', md: props.layout === Layout.SERVICE ? '214px' : '356px' }}
      bgcolor="#F3F2F5"
      flexWrap="wrap"
      overflow="hidden"
      position="relative"
    >
      <Box
        component="figure"
        width="85px"
        height="100px"
        bgcolor="#EC3B96"
        position="absolute"
        margin={0}
        bottom={0}
        left={0}
        zIndex={1}
        sx={{ clipPath: 'polygon(0 0, 0% 100%, 100% 100%)' }}
      />
      <Box
        component="figure"
        width="85px"
        height="100px"
        bgcolor="#7064AE"
        position="absolute"
        margin={0}
        top={0}
        right={0}
        zIndex={1}
        sx={{ clipPath: 'polygon(100% 0, 0 0, 100% 100%)' }}
      />
      <Container maxWidth="lg" sx={{ mx: { xs: 2, md: '85px' }, py: { xs: '100px', md: 2 } }}>
        {layoutRender()}
      </Container>
    </Box>
  );
};

/**
 * GraphQL Query
 */
export const query = graphql`
  fragment SecondaryBanners on StrapiWidgetrels {
    secondaryBanner {
      key: id
      title_en
      title_es
      description_es
      description_en
      widgetPosition
      layout
    }
  }
`;
